export const environmentDevelopment = {
  name: 'development',
  production: false,
  sentry:
    'https://9987870e97f9fa39ff7130ce749c44f9@o508829.ingest.us.sentry.io/4507814853148672',
  mixpanel: '1050fbb4460815e8403ee76d371cc350',
  googleAnalyticsTrackingId: 'G-XN6X7FFY9S',
  facebookAppId: '489291613816841',
  recaptchaSiteKey: '6Ldh4yQqAAAAAA3VM7jj1GyhzJ-5txb0xtzV-9fL',
};
